import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {Item} from '@/components/core';
import Pager from '../_common/pager';
import axios from 'axios'
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';

const formData = [
  { title: '公司名称', maxLength: 30, placeholder: '请填写营业执照上的公司全称', name: 'addressName', required: true },
  { title: '联系人电话', maxLength: 11, placeholder: '请填写您的手机号/联系电话', name: 'phone', required: true },
  { title: '联系人姓名', maxLength: 30, placeholder: '请填写您的姓名', name: 'name', required: false },
  { title: '公司邮箱', maxLength: 30, placeholder: '请填写您的企业邮箱', name: 'email', required: false },
  { title: '需求描述', maxLength: 500, placeholder: '请描述您对行业解决方案、产品的需求', type: 'textarea', name: 'desc', required: false },
]

const customStyles = {
  overlay: {
    backgroundColor: 'transparent'
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    maxWidth: '1200px',
    maxHeight: '675px',
    padding: '8px 16px',
    border: 'none',
    overflow: 'hidden',
    boxShadow: '4px 4px 16px 1px rgba(89,126,247,0.1)'
  },
};

const Form = (props) =>{
  // let inputNumVal = 0
  // const [inputNumVal, setInputNumVal] = React.useState
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setError,
    reset
  } = useForm();

  const onSubmit = (res, e) => {
    if (res.phone && !/^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(17[013678])|(18[0,5-9]))\d{8}$/.test(res.phone)) {
      setError('phone', { type: 'custom', message: '手机号码有误' })
      return false
    }
    // https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=aa47713f-7c77-4d5d-a1ed-077cb73053b3 测试群链接
    // https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=03c7240c-e996-4933-bcfc-16f8b9f66a41  正式群链接
    let data = '标题：【企业官网】－意向客户线索; \n内容：\n'
    let initParams = {} 
    formData.forEach(item => {
      initParams[item.name] = ''
      res[item.name] ? data = data + ( item.title + '：' + res[item.name] + '；\n' ) : ''
    })
    data += '\n该客户通过企业官网留下了联系方式，希望我们能尽快和他联系'
    const params = {
      "msgtype": "text",
      "text": {
        "content": data,
        // "mentioned_list":["wangqing","@all"],
        // "mentioned_mobile_list":["13800001111","@all"]
      }
    }
    axios.post('/wxrobot', params)
    .then((data) => {
      setIsOpen(true);
      setTimeout(() => {
        reset(initParams)
        setIsOpen(false);
      }, 800);
    })
  }
  const onBlur = (e, name) => {
    // console.log(e, name);
    clearErrors(name)
  }
  // const closeModal = () =>{
  //   setIsOpen(false);
  // }
  return (
    <>
      <form className="pages-form" onSubmit={handleSubmit(onSubmit)}>
      {
        formData.map((item, ii) => {
          return (
            <div className="form-item" key={ii}>
              <label className={"form-item-title" + (item.required ? ' required' : '')}>{item.title}：</label>
              <div className="form-item-body">
                {
                  item.type === 'textarea' ?
                    <div className="ss-textarea-wrap">
                      <textarea className="ss-textarea" placeholder={item.placeholder} maxLength={item.maxLength}
                        {...register(item.name, {
                          required: item.required,
                          maxLength: item.maxLength
                        })}
                      ></textarea>
                      {/* {item.num && <div className="form-limit-num"><span>{inputNumVal}</span>/{item.num}</div> } */}
                    </div> :
                    <input
                      autoComplete="off"
                      placeholder={item.placeholder}
                      className={(item.required && errors[item.name]) ? 'ss-input error' : 'ss-input'}
                      maxLength={item.maxLength}
                      {...register(item.name, {
                        required: item.required
                      })}
                      onBlur={(e) => onBlur(e, item.name)}
                    />
                  }
                  {/* {item.required && errors[item.name] && <p className="ss-input-tip">{errorTip}</p>} */}
                  {item.required && errors[item.name] && <p className="ss-input-tip">{errors[item.name].message || '此项为必填项'}</p>}
              </div>
            </div>
          )
        })
      }
      <div className="ss-relative">
        {modalIsOpen ? <p className="pages-form-tips">您的咨询信息已提交成功</p> : ''}
        <input type='submit' value="提交信息" className="ss-button btn-default" />
      </div>
    </form>
    {/* <Modal
      isOpen={modalIsOpen}
      style={customStyles}
    >
     您的咨询信息已提交成功
    </Modal>     */}
    </>
  );
}


const PagesBody = props => {
  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const onChange = (e) => {
    console.log('Change:', e.target.value);
  };

  return (
    <div className="pages-contact-wrap">
      <div className="item-left">
        <div className="item-left-content">
          <div className="item-title">立即咨询我们</div>
          <div className="item-desc">请扫描下方二维码或留下您的联系方式，我们会有专属顾问免费为您提供行业解决方案、产品咨询等服务</div>
          <img src="/images/about/code.jpg" className="item-pic" />
        </div>
      </div>
      <div className="item-right">
       <Form {...{data: formData}}/>
       {/* <Form
          className='pages-form'
          name="basic"
          labelCol={{
            span: 7,
          }}
          wrapperCol={{
            span: 17,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {
            formData.map((item, ii) => {
              return (
                <Form.Item
                  label={item.title}
                  name={item.name}
                  rules={[
                    {
                      required: item.required,
                      message: '此项为必填项',
                    },
                  ]}
                >
                  {
                    item.type === 'textarea' ? <TextArea placeholder={item.placeholder} showCount maxLength={item.num} style={{ height: 100, }} onChange={onChange} /> : <Input placeholder={item.placeholder} />
                  }
                </Form.Item>
              )
            })
          }
          <Form.Item>
            <Button htmlType="submit" className="ss-button btn-default">
              提交信息
            </Button>
          </Form.Item>
        </Form> */}
      </div>
    </div>
  )
}

const cfg = {
  body: <PagesBody />,
  footer: <div></div>
}
const App = () => (
  <Pager {...cfg} />
);

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)




// class Form extends React.Component{
// 	constructor(props) {
// 		super();
// 		this.state = {
//       fields: {
//       }
			
//       // validator: {
//       //   addressName,
//       //   phone
//       // }
// 		}
//     console.log(props, '====== this', this);
// 	}
// 	render(){
// 		return (
// 			<form className="pages-form" onSubmit={this.submit.bind(this)}>
//         {
//           formData.map((item, ii) => {
//             return (
//               <div className="form-item" key={ii}>
//                 <label className={"form-item-title" + (item.required ? ' required' : '')}>{item.title}：</label>
//                 <div className="form-item-body">
//                   {
//                     // item.type === 'textarea' ?
//                     //   <div className="ss-textarea-wrap">
//                     //     <textarea className="ss-textarea" placeholder={item.placeholder} name={item.name} value={this.state[item.name]} onChange={this.change.bind(this, item.name)}></textarea>
//                     //     {/* {item.num && <div className="form-limit-num"><span>{inputNumVal}</span>/{item.num}</div> } */}
//                     //   </div> :
//                       <input className="ss-input" autoComplete="off" type={item.type || 'text'} name={item.name} onChange={this.change.bind(this, item.name)} placeholder={item.placeholder} />
//                   }
//                   {/* {
//                     item.required ? <div>{this.state.validator[item.name]}</div> : ''
//                   } */}
//                 </div>
//               </div>
//             )
//           })
//         }
//         <input type='submit' className="ss-button btn-default" />
//       </form>
// 		)
// 	}
//   validate(cb) {


//   }
// 	submit(event)	{
// 		event.preventDefault()
//     if (!this.state.addressName || !this.state.phone){
//       this.validate()
//       return false
//     }
//     const fields = this.state.fields;
//     const values = {};
//     Object.keys(fields).forEach(field => {
//         values[field] = fields[field].value
//     });
//     console.log(values);
//     // https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=aa47713f-7c77-4d5d-a1ed-077cb73053b3 测试群链接
//     // https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=03c7240c-e996-4933-bcfc-16f8b9f66a41  正式群链接
//     // let data = '标题：【企业官网】－意向客户线索; 内容：'
//     // formData.forEach(item => {
//     //   this.state[item.name] ? data = data + ( item.title + '：' + this.state[item.name] + '；' ) : ''
//     // })
//     // const xx = {
//     //   "msgtype": "text",
//     //   "text": {
//     //     "content": data,
//     //     // "mentioned_list":["wangqing","@all"],
//     //     // "mentioned_mobile_list":["13800001111","@all"]
//     //   }
//     // }
//     // axios.post('https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=aa47713f-7c77-4d5d-a1ed-077cb73053b3', xx);
    
// 	}

// 	change(name, event) {
// 		this.setState({
// 			[name]: event.target.value
// 		})
// 	}

// }